import type { CircleLayer, SymbolLayer } from 'react-map-gl';

/**
 * Numbered stop markers for the selected driver's route in the Capacity
 * Planning Result tab: a coloured dot (`capacityPlanStopsCircleLayer`) with
 * the stop's sequence number on top (`capacityPlanStopsNumberLayer`).
 */
export const capacityPlanStopsCircleLayer: CircleLayer = {
  id: 'capacityPlanStops',
  type: 'circle',
  paint: {
    'circle-radius': ['case', ['get', 'focused'], 14.4, 9],
    'circle-color': ['get', 'colour'],
    'circle-stroke-width': ['case', ['get', 'focused'], 4, 2],
    'circle-stroke-color': '#ffffff',
  },
};

export const capacityPlanStopsNumberLayer: SymbolLayer = {
  id: 'capacityPlanStopNumbers',
  type: 'symbol',
  layout: {
    'text-field': ['to-string', ['get', 'sequence']],
    'text-size': 11,
    'text-allow-overlap': true,
  },
  paint: {
    'text-color': '#ffffff',
  },
};
